import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";
export const ContentCard = styled.div`
  width: 100%;
  height: 106px;
  cursor: pointer;
  margin-bottom: 10px;
  .content-card {
    box-sizing: border-box;
    height: 100%;
    background-color: #F2F2F7;
    border: 2px solid #FFFFFF;
    box-shadow: 0px 3px 9.5px 1px #9395CC24;
    border-radius: 20px;
    padding: 6px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    &__separation {
      height: 45px;
      margin: 0 20px;
      border-right: 1px solid #707582;
    }
    &__img {
      height: 100%;
      margin-right: 5px;
      width: 53px;
      img {
        height: 100%;
        width: 100%;
        border-radius: 15px;
        object-fit: cover;
      }
    }
    &__principal {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
      width: 100%;
      max-width: 280px;
      .content-title {
        font-size: 16px;
        font-weight: 600;
        color: #000000;
        margin-bottom: 4px;
        height: 46px;
        display: -webkit-box;
        -webkit-line-clamp: 2;       /* Número máximo de líneas */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .content-seasons {
        font-size: 14px;
        font-family: "Nunito Sans";
        color: #3E3E5B;
      }
    }
    &__categories {
      color: #1F1F52;
      font-size: 14px;
    }
    &__description {
      color: #1F1F52;
      font-family: Nunito Sans;
      font-size: 14px;
      width: 258px;
      display: -webkit-box;
      -webkit-line-clamp: 4;       /* Número máximo de líneas */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__options {
      .access-programs {
        margin-bottom: 5px;
        text-align: end;
        &__text {
          font-family: Nunito Sans;
          font-size: 14px;
          color: #1F1F52;
        }
      }
      .button-container {
        width: 190px;
      }
    }
  }
`;